module.exports = "https://www.gc-pro.gnp.com.mx/2b1ace1425f518158c57b701fca26586.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/notificacion.svg
// module id = 698
// module chunks = 0